import { render } from "./PurposeChart.vue?vue&type=template&id=8901c7ba"
import script from "./PurposeChart.vue?vue&type=script&lang=js"
export * from "./PurposeChart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__